module.exports = __webpack_public_path__ + "img/logo_nuevo.427996a5.png";